import { __, __parameter } from "@/services/translations";

export default {
  install(Vue) {

    Vue.prototype._ = _;
    Vue.prototype.$dateTime = window.DateTime;
    Vue.prototype.$laravel = window.Laravel;
    Vue.prototype.$laravel.route = window.route;
    Vue.prototype.$uuid = uuid;
    Vue.prototype.$__ = __;
    Vue.prototype.$__parameter = __parameter;
    Vue.prototype.$erp = {
      getColorNameById: window.getColorNameById,
      getFinitionNameById: window.getFinitionNameById,
      getBaseParameter: window.getBaseParameter,
      isColorParameter: window.isColorParameter,
      isFinitionParameter: window.isFinitionParameter,
      isNumericParameter: window.isNumericParameter,
      isOptionParameter: window.isOptionParameter
    };
    Vue.prototype.$haveProductionMinutesDepartments = window.haveProductionMinutesDepartments;

    /*
     |--------------------------------------------------------------------------
     | Directives
     |--------------------------------------------------------------------------
     */

    Vue.directive("loading", {
      inserted(el, binding, vnode) {
        let loadingMask = document.createElement("div");
        loadingMask.className = "loading-mask";
        el.appendChild(loadingMask);
        if (binding.value) {
          loadingMask.className += " is-active";
        }
      },
      update(el, binding, vnode) {
        let loadingMask = null;
        for (var i = 0; i < el.childNodes.length; i++) {
          if ((el.childNodes[i].className || "").includes("loading-mask")) {
            loadingMask = el.childNodes[i];
            break;
          }
        }

        if (binding.value) {
          loadingMask.className += " is-active";
        } else {
          loadingMask.className = "loading-mask";
        }
      }
    });

    /*
     |--------------------------------------------------------------------------
     | Prototypes
     |--------------------------------------------------------------------------
     */

    Vue.prototype.$redirect = function (url) {
      if (url !== undefined) {
        window.location.href = url;
      } else {
        // eslint-disable-next-line no-console
        console.error("url in $redirect() is undefined");
      }
    };

    Vue.prototype.$refresh = function () {
      location.reload();
    };

    Vue.prototype.$logout = function () {
      this.$http.post("/logout")
        .then(response => {
          window.location.href = "/";
        })
        .catch(error => {
          window.location.href = "/";
        });
    };
  }
};
